import {
  ENUM_COMPONENTSECTIONSCARDTYPE_SECTIONTYPE,
  Maybe,
} from './globalTypes'

import { GridType, isGridType } from './GridType'

import {
  BentoCardFragment,
  isBentoCardFragment,
} from './BentoCardFragment'

import {
  ImageDiffFragment,
  isImageDiffFragment,
} from './ImageDiffFragment'

import cardTypeSectionFragmentRawString from '../../fragments/CardTypeSectionFragment.graphql'

export const cardTypeSectionFragmentString = cardTypeSectionFragmentRawString

export type CardTypeSectionFragment = {
  __typename: 'ComponentSectionsCardType'
  id: string
  sectionType: ENUM_COMPONENTSECTIONSCARDTYPE_SECTIONTYPE
  gridTitle: Maybe<string>
  gridDescription: Maybe<string>
  gridSubtitle: Maybe<string>
  isComponentRight: Maybe<boolean>
  bentoImage: Maybe<{
    imageUrl: {
      url: string
    }
  }>
  gridArea: Maybe<GridType>
  childrenGridArea: Maybe<GridType>
  blobs: Maybe<{
    id: string
    option: Maybe<number>
    height: Maybe<string>
    width: Maybe<string>
    positionBottom: Maybe<string>
    glassBlur: Maybe<number>
  }>
  gridColumnOverride: Maybe<string>
  gridRowOverride: Maybe<string>
  cards: Maybe<BentoCardFragment>[]
  imageDiffs: Maybe<Maybe<ImageDiffFragment>[]>
}

export const isCardTypeSectionFragment = (
  fragment: any,
): fragment is CardTypeSectionFragment =>
  fragment &&
  fragment.__typename === 'ComponentSectionsCardType' &&
  typeof fragment.id === 'string' &&
  (fragment.sectionType === 'static_image' ||
    fragment.sectionType === 'image_diff' ||
    fragment.sectionType === 'image_slider') &&
  (fragment.gridTitle === null || typeof fragment.gridTitle === 'string') &&
  (fragment.gridDescription === null ||
    typeof fragment.gridDescription === 'string') &&
  (fragment.gridSubtitle === null ||
    typeof fragment.gridSubtitle === 'string') &&
  (fragment.isComponentRight === null ||
    typeof fragment.isComponentRight === 'boolean') &&
  (fragment.bentoImage === null ||
    (fragment.bentoImage &&
      fragment.bentoImage.imageUrl &&
      typeof fragment.bentoImage.imageUrl.url === 'string')) &&
  (fragment.gridArea === null || (isGridType(fragment.gridArea) as boolean)) &&
  (fragment.childrenGridArea === null ||
    (isGridType(fragment.childrenGridArea) as boolean)) &&
  (fragment.blobs === null ||
    (fragment.blobs &&
      typeof fragment.blobs.id === 'string' &&
      (fragment.blobs.option === null ||
        typeof fragment.blobs.option === 'number') &&
      (fragment.blobs.height === null ||
        typeof fragment.blobs.height === 'string') &&
      (fragment.blobs.width === null ||
        typeof fragment.blobs.width === 'string') &&
      (fragment.blobs.positionBottom === null ||
        typeof fragment.blobs.positionBottom === 'string') &&
      (fragment.blobs.glassBlur === null ||
        typeof fragment.blobs.glassBlur === 'number'))) &&
  (fragment.gridColumnOverride === null ||
    typeof fragment.gridColumnOverride === 'string') &&
  (fragment.gridRowOverride === null ||
    typeof fragment.gridRowOverride === 'string') &&
  Array.isArray(fragment.cards) &&
  fragment.cards
    .slice(0, 5)
    .reduce(
      (accum: any, next: any) =>
        accum && (next === null || (isBentoCardFragment(next) as boolean)),
      true,
    ) &&
  (fragment.imageDiffs === null ||
    (Array.isArray(fragment.imageDiffs) &&
      fragment.imageDiffs
        .slice(0, 5)
        .reduce(
          (accum: any, next: any) =>
            accum && (next === null || (isImageDiffFragment(next) as boolean)),
          true,
        )))
